import { Component, Input } from '@angular/core';
import { CommaSeparatedToArrayPipe } from '../../../../pipes/comma-separated-to-array.pipe';
import { CarrierInParenthesisPipe } from '../../pipes/carrier-in-parenthesis.pipe';
import { RoutingBookedComponent } from './routing-booked/routing-booked.component';
import { RoutingConfirmedComponent } from './routing-confirmed/routing-confirmed.component';
import { Shipment } from '../../../../pages/overview/models/shipment';
import { Container } from '../../../../pages/overview/models/container';

@Component({
  selector: 'app-routing',
  standalone: true,
  templateUrl: './routing.component.html',
  imports: [CommaSeparatedToArrayPipe, CarrierInParenthesisPipe, RoutingBookedComponent, RoutingConfirmedComponent],
  styleUrl: './routing.component.scss'
})
export class RoutingComponent {
  @Input() item: Shipment | Container | null = null;
}
